export const NEWS_ERROR = "NEWS_ERROR";
export const NEWS_SUCCESS = "NEWS_SUCCESS";

export function newsSuccess(newsItems) {
    return {
        type: NEWS_SUCCESS,
        newsItems
    };
}

export function newsError(msg) {
    return {
        type: NEWS_ERROR,
        msg
    };
}
